import { useCallback, useContext, useState } from "react";
import CustomModal from "../CustomModal/CustomModal";
import styles from "./StandardBundleTemplate.module.css";
import { Button, ButtonGroup, ColorPicker, Popover, TextField } from "@shopify/polaris";
import { StandardPreview } from "../../apps/Bundles/Standard/StandardBundle/StandardBundle";
import { AvailableStandardTemplates } from "../../apps/Bundles/constants";
import { AppConfigContext } from "../../context/AppConfigContext";
import { StandardBundleContext } from "../../apps/Bundles/Standard/Standard";
import { hexToHsla, hslaToHex, lightenHexColor, darkenHexColor } from "../../utilities/parsers";
// import { initialConfigData } from "../../apps/Bundles/Standard/useStandardHook";
import useIsMobile from "../../hooks/useIsMobile";

const StandardBundleTemplate = ({
    setOpenStandardTemplateModal,
    bundleConfig,
    dispatchBundleConfig,
    forAiBundle = false,
}: {
    openStandardTemplateModal: any;
    setOpenStandardTemplateModal: any;
    bundleConfig: any;
    standAlone: any;
    dispatchBundleConfig: any;
    forAiBundle?: boolean;
}) => {
    const appConfigContext = useContext(AppConfigContext);

    const context = useContext(StandardBundleContext);
    const {
        fields: { bundles_design, selected_template_standard },
    } = context;
    const [popoverActive, setPopoverActive] = useState<boolean>(false);
    const togglePopoverActive = useCallback(() => setPopoverActive((active) => !active), []);
    const { isMobile } = useIsMobile();
    const handleChangeBundleDesign = (color: keyof typeof stanTempColor) => {
        const newBundleDesign: any = stanTempColor[color];
        // newBundleDesign["default_cta"] = bundleConfig.bundles_design.default_cta;
        // newBundleDesign["add_to_cart_border_radius"] = bundleConfig.bundles_design.add_to_cart_border_radius;
        // newBundleDesign["add_to_cart_border_width"] = bundleConfig.bundles_design.add_to_cart_border_width;
        // newBundleDesign["add_to_cart_text_color"] = bundleConfig.bundles_design.add_to_cart_text_color;
        // newBundleDesign["add_to_cart_text_size"] = bundleConfig.bundles_design.add_to_cart_text_size;
        // newBundleDesign["add_to_cart_text_style"] = bundleConfig.bundles_design.add_to_cart_text_style;

        dispatchBundleConfig({
            payload: {
                ...bundleConfig.bundles_design,
                ...newBundleDesign,
            },
            isComplex: true,
            key: "bundles_design",
        });
        Object.entries(bundles_design).forEach((key) => {
            // @ts-expect-error hack
            key[1].onChange(bundleConfig.bundles_design[key[0]]);
            if (key[0] in newBundleDesign) {
                // @ts-expect-error hack
                key[1].onChange(newBundleDesign[key[0]]);
            }
        });
    };

    const handleChangeSelectedTemplate = (template: any) => {
        dispatchBundleConfig({
            payload: template,
            key: "selected_template_standard",
        });
        selected_template_standard.onChange(template);

        setOpenStandardTemplateModal(false);
    };

    const [color, setColor] = useState({
        hue: 120,
        brightness: 1,
        saturation: 1,
    });
    const [hexColor, setHexColor] = useState("");

    const handleColorChange = (newColor: any) => {
        setColor(newColor);
        const { hue, brightness, saturation } = newColor;
        const hslaColor = `hsla(${hue}, ${saturation * 100}%, ${brightness * 100}%, 1)`;
        const hex = hslaToHex(hslaColor);
        setHexColor(hex);

        const newTemp = {
            add_to_cart_bg_color: hex,
            // add_to_cart_border_radius: bundleConfig.bundles_design.add_to_cart_border_radius,
            add_to_cart_border_color: darkenHexColor(hex, 20),
            // add_to_cart_border_width: bundleConfig.bundles_design.add_to_cart_border_width,
            // add_to_cart_text_color: bundleConfig.bundles_design.add_to_cart_text_color,
            // add_to_cart_text_size: bundleConfig.bundles_design.add_to_cart_text_size,
            // add_to_cart_text_style: bundleConfig.bundles_design.add_to_cart_text_style,
            bundle_title_color: hex,
            // product_name_color: "#050505",
            // product_price_color: "#050505",
            // border_color: "#050505",
            // highlighted_offer_tag_color: "#F8F8F8",
            // highlighted_price_tag_color: "#050505",
            // total_footer_text_color: "#000000",
            // total_footer_price_text_color: "#000000",
            total_footer_background_color: lightenHexColor(hex, 70),
            product_background_color: lightenHexColor(hex, 70),
            product_border_color: hex,
            special_text_background_color: hex,
            special_text_color: newColor.brightness >= 0.5 ? "#050505" : "#ffffff",
            // bundle_widget_bg: "#ffffff00",

            free_gift_header_bg_color: hex,
            free_gift_header_color: brightness >= 0.5 ? "#050505" : "#ffffff",
            // free_gift_header_size: 15,
            // free_gift_header_style: "650 normal",
            free_gift_bg_color: lightenHexColor(hex, 70),
            free_gift_text_color: newColor.brightness >= 0.5 ? "#050505" : "#ffffff",
            // free_gift_text_size: 12,
            // free_gift_text_style: "550 normal",
            // free_gift_border: true,
            // free_gift_border_width: 0,
            // free_gift_border_color: "#050505",
            // default_cta: bundleConfig.bundles_design.default_cta,
            swatches_select_color: hex,
            variant_selector_text_color: hex,
            bundle_border_color: hex,
        };

        dispatchBundleConfig({
            payload: {
                ...bundleConfig.bundles_design,
                ...newTemp,
            },
            isComplex: true,
            key: "bundles_design",
        });

        Object.entries(bundles_design).forEach((key) => {
            // @ts-expect-error hack
            key[1].onChange(bundleConfig.bundles_design[key[0]]);
            if (key[0] in newTemp) {
                // @ts-expect-error hack
                key[1].onChange(newTemp[key[0]]);
            }
        });
    };

    return (
        <CustomModal
            open={true}
            title="Choose a Template"
            key={"template_sb"}
            onClose={() => setOpenStandardTemplateModal(false)}
            primaryAction={{
                content: "Close",
                plain: true,
                onAction: () => setOpenStandardTemplateModal(false),
            }}
            size={forAiBundle ? undefined : "large"}
        >
            <div className={styles.colorWrapper}>
                <h6 className={styles.colorWrapperTitle}>Color Theme</h6>
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        position: "relative",
                    }}
                >
                    <ButtonGroup variant="segmented" noWrap>
                        {isMobile
                            ? Object.keys(stanTempColor).slice(0, 5)
                            : Object.keys(stanTempColor).map((t: any) => (
                                  <Button
                                      size="micro"
                                      onClick={() => {
                                          handleChangeBundleDesign(t);
                                      }}
                                  >
                                      {/* @ts-expect-error no react elements allowed */}
                                      <div
                                          style={{
                                              backgroundColor: t,
                                          }}
                                          className={styles.colorBtn}
                                      ></div>
                                  </Button>
                              ))}

                        <Popover
                            active={popoverActive}
                            preferredAlignment="right"
                            activator={
                                <Button
                                    size="micro"
                                    onClick={() => {
                                        togglePopoverActive();
                                    }}
                                >
                                    {/* @ts-expect-error no react elements allowed */}
                                    <div
                                        style={{
                                            height: "20px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                            fontWeight: "500",
                                            position: "relative",
                                        }}
                                    >
                                        <span
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                width: "20px",
                                                height: "20px",
                                                border: "2px dotted #d2d5db",
                                                borderRadius: "50%",
                                                fontSize: "16px",
                                            }}
                                        >
                                            +
                                        </span>
                                        <span className={styles.customText}>Custom</span>
                                    </div>
                                </Button>
                            }
                            onClose={togglePopoverActive}
                        >
                            <div
                                style={{
                                    // position: "absolute",
                                    // top: "30px",
                                    // right: "0",
                                    backgroundColor: "#ffffff",
                                    padding: "12px",
                                    borderRadius: "8px",
                                    zIndex: 10,
                                    border: "1px solid lightgray",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                <ColorPicker onChange={handleColorChange} color={color} />
                                <TextField
                                    label=""
                                    autoComplete="off"
                                    placeholder="#ffffff"
                                    maxLength={7}
                                    value={hexColor}
                                    onChange={(val) => {
                                        console._log(val);
                                        setHexColor(val);
                                        if (val.length == 7 && val.startsWith("#")) {
                                            const hslaColor = hexToHsla(val);
                                            handleColorChange(hslaColor);
                                        }
                                    }}
                                />
                            </div>
                        </Popover>
                    </ButtonGroup>
                </div>
            </div>

            <div
                className={styles.mainContainer}
                style={{
                    // @ts-expect-error required
                    "--columns": forAiBundle ? "1fr" : " 1fr 1fr",
                }}
            >
                <div className={styles.container}>
                    <StandardPreview
                        bundleConfig={{
                            ...bundleConfig,
                            selected_template_standard: AvailableStandardTemplates.HORIZONTAL_BASIC,
                            general_settings: {
                                show_powered_by_kefi: false,
                            },
                        }}
                        standAlone={false}
                        appConfigContext={appConfigContext}
                        targetForm={""}
                    />
                    <Button
                        variant={
                            selected_template_standard.value == AvailableStandardTemplates.HORIZONTAL_BASIC
                                ? "primary"
                                : "secondary"
                        }
                        onClick={() => {
                            handleChangeSelectedTemplate(AvailableStandardTemplates.HORIZONTAL_BASIC);
                        }}
                    >
                        {selected_template_standard.value == AvailableStandardTemplates.HORIZONTAL_BASIC
                            ? "Selected"
                            : "Select"}
                    </Button>
                </div>

                <div className={styles.container}>
                    <StandardPreview
                        bundleConfig={{
                            ...bundleConfig,
                            selected_template_standard: AvailableStandardTemplates.VERTICAL_BASIC,
                            general_settings: {
                                show_powered_by_kefi: false,
                            },
                        }}
                        standAlone={false}
                        appConfigContext={appConfigContext}
                        targetForm={""}
                    />
                    <Button
                        variant={
                            selected_template_standard.value == AvailableStandardTemplates.VERTICAL_BASIC
                                ? "primary"
                                : "secondary"
                        }
                        onClick={() => {
                            handleChangeSelectedTemplate(AvailableStandardTemplates.VERTICAL_BASIC);
                        }}
                    >
                        {selected_template_standard.value == AvailableStandardTemplates.VERTICAL_BASIC
                            ? "Selected"
                            : "Select"}
                    </Button>
                </div>

                <div className={styles.container}>
                    <StandardPreview
                        bundleConfig={{
                            ...bundleConfig,
                            selected_template_standard: AvailableStandardTemplates.VERTICAL_CLASSIC,
                            general_settings: {
                                show_powered_by_kefi: false,
                            },
                        }}
                        standAlone={false}
                        appConfigContext={appConfigContext}
                        targetForm={""}
                    />
                    <Button
                        variant={
                            selected_template_standard.value == AvailableStandardTemplates.VERTICAL_CLASSIC
                                ? "primary"
                                : "secondary"
                        }
                        onClick={() => {
                            handleChangeSelectedTemplate(AvailableStandardTemplates.VERTICAL_CLASSIC);
                        }}
                    >
                        {selected_template_standard.value == AvailableStandardTemplates.VERTICAL_CLASSIC
                            ? "Selected"
                            : "Select"}
                    </Button>
                </div>
            </div>
        </CustomModal>
    );
};

export default StandardBundleTemplate;

const stanTempColor = {
    BLACK: {
        // bundle_title_size: 22,
        bundle_title_color: "#000000",
        swatches_select_color: "#000000",
        variant_selector_text_color: "#000000",

        bundle_border_color: "#000000",
        // bundle_title_style: "650 normal",
        // product_name_size: 14,
        // product_name_color: "#050505",
        // product_name_style: "450 normal",
        // product_price_size: 10,
        // product_price_color: "#050505",
        // product_price_style: "350 normal",
        // border_color: "#050505",
        // border_width: 2,
        // border_radius: 8,
        background_color: "#F2F4F2",
        // highlighted_offer_tag_size: 12,
        // highlighted_offer_tag_color: "#F8F8F8",
        // highlighted_offer_tag_style: "550 italic",
        // highlighted_price_tag_size: 14,
        // highlighted_price_tag_color: "#050505",
        // highlighted_price_tag_style: "750 normal",
        // total_footer_text_size: 14,
        // total_footer_text_color: "#000000",
        // total_footer_text_style: "550 normal",
        // total_footer_price_text_size: 16,
        // total_footer_price_text_color: "#000000",
        // total_footer_price_text_style: "750 normal",
        total_footer_background_color: "#f0f0f0",
        // total_footer_background_style: "450 normal",
        product_background_color: "#f0f0f0",
        product_border_color: "#303030",
        // bundle_widget_bg: "#ffffff00",
        // bundle_widget_font_family: "Custom Store Font",
        // product_img_size: "medium",
        // product_img_show: "all",
        // product_img_border_radius: 10,
        free_gift_header_bg_color: "#303030",
        free_gift_header_color: "#ffffff",
        // free_gift_header_size: 13,
        // free_gift_header_style: "650 normal",
        free_gift_bg_color: "#f0f0f0",
        free_gift_text_color: "#303030",
        // free_gift_text_size: 12,
        // free_gift_text_style: "650 normal",
        // free_gift_border: true,
        // free_gift_border_width: 0,
        // free_gift_border_color: "#441144",
        // product_img_border_width: 1,
        product_img_border_color: "#cccccc",
        add_to_cart_bg_color: "#303030",
        add_to_cart_border_color: "#000000",
    },
    RED: {
        // bundle_title_size: 22,
        bundle_title_color: "#ff2d2d",
        swatches_select_color: "#ff2d2d",
        variant_selector_text_color: "#ff2d2d",
        bundle_border_color: "#ff2d2d",
        // bundle_title_style: "650 normal",
        // product_name_size: 14,
        // product_name_color: "#050505",
        // product_name_style: "450 normal",
        // product_price_size: 10,
        // product_price_color: "#050505",
        // product_price_style: "350 normal",
        // border_color: "#050505",
        // border_width: 2,
        // border_radius: 8,
        background_color: "#F2F4F2",
        // highlighted_offer_tag_size: 12,
        // highlighted_offer_tag_color: "#F8F8F8",
        // highlighted_offer_tag_style: "550 italic",
        // highlighted_price_tag_size: 14,
        // highlighted_price_tag_color: "#050505",
        // highlighted_price_tag_style: "750 normal",
        // total_footer_text_size: 14,
        // total_footer_text_color: "#000000",
        // total_footer_text_style: "550 normal",
        // total_footer_price_text_size: 16,
        // total_footer_price_text_color: "#000000",
        // total_footer_price_text_style: "750 normal",
        total_footer_background_color: "#ffe4e4",
        // total_footer_background_style: "450 normal",
        product_background_color: "#ffe4e4",
        product_border_color: "#ff4040",
        // bundle_widget_bg: "#ffffff00",
        // bundle_widget_font_family: "Custom Store Font",
        // product_img_size: "medium",
        // product_img_show: "all",
        // product_img_border_radius: 10,
        free_gift_header_bg_color: "#ff4040",
        free_gift_header_color: "#ffffff",
        // free_gift_header_size: 13,
        // free_gift_header_style: "650 normal",
        free_gift_bg_color: "#ffe4e4",
        free_gift_text_color: "#303030",
        // free_gift_text_size: 12,
        // free_gift_text_style: "650 normal",
        // free_gift_border: true,
        // free_gift_border_width: 0,
        // free_gift_border_color: "#441144",
        // product_img_border_width: 1,
        product_img_border_color: "#cccccc",
        add_to_cart_bg_color: "#ff0000",
        add_to_cart_border_color: "#cc0000",
    },
    ORANGE: {
        // bundle_title_size: 22,
        bundle_title_color: "#ff6813",
        swatches_select_color: "#ff6813",
        variant_selector_text_color: "#ff6813",

        bundle_border_color: "#ff6813",
        // bundle_title_style: "650 normal",
        // product_name_size: 14,
        // product_name_color: "#050505",
        // product_name_style: "450 normal",
        // product_price_size: 10,
        // product_price_color: "#050505",
        // product_price_style: "350 normal",
        // border_color: "#050505",
        // border_width: 2,
        // border_radius: 8,
        background_color: "#F2F4F2",
        // highlighted_offer_tag_size: 12,
        // highlighted_offer_tag_color: "#F8F8F8",
        // highlighted_offer_tag_style: "550 italic",
        // highlighted_price_tag_size: 14,
        // highlighted_price_tag_color: "#050505",
        // highlighted_price_tag_style: "750 normal",
        // total_footer_text_size: 14,
        // total_footer_text_color: "#000000",
        // total_footer_text_style: "550 normal",
        // total_footer_price_text_size: 16,
        // total_footer_price_text_color: "#000000",
        // total_footer_price_text_style: "750 normal",
        total_footer_background_color: "#ffe7dd",
        // total_footer_background_style: "450 normal",
        product_background_color: "#ffe7dd",
        product_border_color: "#ff550a",
        // bundle_widget_bg: "#ffffff00",
        // bundle_widget_font_family: "Custom Store Font",
        // product_img_size: "medium",
        // product_img_show: "all",
        // product_img_border_radius: 10,
        free_gift_header_bg_color: "#ff550a",
        free_gift_header_color: "#ffffff",
        // free_gift_header_size: 13,
        // free_gift_header_style: "650 normal",
        free_gift_bg_color: "#ffe7dd",
        free_gift_text_color: "#303030",
        // free_gift_text_size: 12,
        // free_gift_text_style: "650 normal",
        // free_gift_border: true,
        // free_gift_border_width: 0,
        // free_gift_border_color: "#441144",
        // product_img_border_width: 1,
        product_img_border_color: "#cccccc",
        add_to_cart_bg_color: "#ff7a00",
        add_to_cart_border_color: "#cc7a00",
    },
    LIME: {
        // bundle_title_size: 22,
        bundle_title_color: "#68ff1a",
        swatches_select_color: "#68ff1a",
        variant_selector_text_color: "#68ff1a",
        bundle_border_color: "#68ff1a",
        // bundle_title_style: "650 normal",
        // product_name_size: 14,
        // product_name_color: "#050505",
        // product_name_style: "450 normal",
        // product_price_size: 10,
        // product_price_color: "#050505",
        // product_price_style: "350 normal",
        // border_color: "#050505",
        // border_width: 2,
        // border_radius: 8,
        background_color: "#F2F4F2",
        // highlighted_offer_tag_size: 12,
        // highlighted_offer_tag_color: "#F8F8F8",
        // highlighted_offer_tag_style: "550 italic",
        // highlighted_price_tag_size: 14,
        // highlighted_price_tag_color: "#050505",
        // highlighted_price_tag_style: "750 normal",
        // total_footer_text_size: 14,
        // total_footer_text_color: "#000000",
        // total_footer_text_style: "550 normal",
        // total_footer_price_text_size: 16,
        // total_footer_price_text_color: "#000000",
        // total_footer_price_text_style: "750 normal",
        total_footer_background_color: "#eaffdf",
        // total_footer_background_style: "450 normal",
        product_background_color: "#eaffdf",
        product_border_color: "#68ff1a",
        // bundle_widget_bg: "#ffffff00",
        // bundle_widget_font_family: "Custom Store Font",
        // product_img_size: "medium",
        // product_img_show: "all",
        // product_img_border_radius: 10,
        free_gift_header_bg_color: "#68ff1a",
        free_gift_header_color: "#303030",
        // free_gift_header_size: 13,
        // free_gift_header_style: "650 normal",
        free_gift_bg_color: "#eaffdf",
        free_gift_text_color: "#303030",
        // free_gift_text_size: 12,
        // free_gift_text_style: "650 normal",
        // free_gift_border: true,
        // free_gift_border_width: 0,
        // free_gift_border_color: "#441144",
        // product_img_border_width: 1,
        product_img_border_color: "#cccccc",
        add_to_cart_bg_color: "#73ff00",
        add_to_cart_border_color: "#73cc00",
    },
    GREEN: {
        // bundle_title_size: 22,
        bundle_title_color: "#399907",
        swatches_select_color: "#399907",
        variant_selector_text_color: "#399907",
        bundle_border_color: "#399907",
        // bundle_title_style: "650 normal",
        // product_name_size: 14,
        // product_name_color: "#050505",
        // product_name_style: "450 normal",
        // product_price_size: 10,
        // product_price_color: "#050505",
        // product_price_style: "350 normal",
        // border_color: "#050505",
        // border_width: 2,
        // border_radius: 8,
        background_color: "#F2F4F2",
        // highlighted_offer_tag_size: 12,
        // highlighted_offer_tag_color: "#F8F8F8",
        // highlighted_offer_tag_style: "550 italic",
        // highlighted_price_tag_size: 14,
        // highlighted_price_tag_color: "#050505",
        // highlighted_price_tag_style: "750 normal",
        // total_footer_text_size: 14,
        // total_footer_text_color: "#000000",
        // total_footer_text_style: "550 normal",
        // total_footer_price_text_size: 16,
        // total_footer_price_text_color: "#000000",
        // total_footer_price_text_style: "750 normal",
        total_footer_background_color: "#dffdd0",
        // total_footer_background_style: "450 normal",
        product_background_color: "#dffdd0",
        product_border_color: "#399907",
        // bundle_widget_bg: "#ffffff00",
        // bundle_widget_font_family: "Custom Store Font",
        // product_img_size: "medium",
        // product_img_show: "all",
        // product_img_border_radius: 10,
        free_gift_header_bg_color: "#399907",
        free_gift_header_color: "#ffffff",
        // free_gift_header_size: 13,
        // free_gift_header_style: "650 normal",
        free_gift_bg_color: "#dffdd0",
        free_gift_text_color: "#303030",
        // free_gift_text_size: 12,
        // free_gift_text_style: "650 normal",
        // free_gift_border: true,
        // free_gift_border_width: 0,
        // free_gift_border_color: "#441144",
        // product_img_border_width: 1,
        product_img_border_color: "#cccccc",
        add_to_cart_bg_color: "#5cd600",
        add_to_cart_border_color: "#5ca300",
    },
    BLUE: {
        // bundle_title_size: 22,
        bundle_title_color: "#073099",
        swatches_select_color: "#073099",
        variant_selector_text_color: "#073099",
        bundle_border_color: "#073099",
        // bundle_title_style: "650 normal",
        // product_name_size: 14,
        // product_name_color: "#050505",
        // product_name_style: "450 normal",
        // product_price_size: 10,
        // product_price_color: "#050505",
        // product_price_style: "350 normal",
        // border_color: "#050505",
        // border_width: 2,
        // border_radius: 8,
        background_color: "#F2F4F2",
        // highlighted_offer_tag_size: 12,
        // highlighted_offer_tag_color: "#F8F8F8",
        // highlighted_offer_tag_style: "550 italic",
        // highlighted_price_tag_size: 14,
        // highlighted_price_tag_color: "#050505",
        // highlighted_price_tag_style: "750 normal",
        // total_footer_text_size: 14,
        // total_footer_text_color: "#000000",
        // total_footer_text_style: "550 normal",
        // total_footer_price_text_size: 16,
        // total_footer_price_text_color: "#000000",
        // total_footer_price_text_style: "750 normal",
        total_footer_background_color: "#d1ebff",
        // total_footer_background_style: "450 normal",
        product_background_color: "#d1ebff",
        product_border_color: "#0067b4",
        // bundle_widget_bg: "#ffffff00",
        // bundle_widget_font_family: "Custom Store Font",
        // product_img_size: "medium",
        // product_img_show: "all",
        // product_img_border_radius: 10,
        free_gift_header_bg_color: "#0067b4",
        free_gift_header_color: "#ffffff",
        // free_gift_header_size: 13,
        // free_gift_header_style: "650 normal",
        free_gift_bg_color: "#d1ebff",
        free_gift_text_color: "#303030",
        // free_gift_text_size: 12,
        // free_gift_text_style: "650 normal",
        // free_gift_border: true,
        // free_gift_border_width: 0,
        // free_gift_border_color: "#441144",
        // product_img_border_width: 1,
        product_img_border_color: "#cccccc",
        add_to_cart_bg_color: "#0096ff",
        add_to_cart_border_color: "#0096cc",
    },
    PURPLE: {
        // bundle_title_size: 22,
        bundle_title_color: "#990783",
        swatches_select_color: "#990783",
        variant_selector_text_color: "#990783",
        bundle_border_color: "#990783",
        // bundle_title_style: "650 normal",
        // product_name_size: 14,
        // product_name_color: "#050505",
        // product_name_style: "450 normal",
        // product_price_size: 10,
        // product_price_color: "#050505",
        // product_price_style: "350 normal",
        // border_color: "#050505",
        // border_width: 2,
        // border_radius: 8,
        background_color: "#F2F4F2",
        // highlighted_offer_tag_size: 12,
        // highlighted_offer_tag_color: "#F8F8F8",
        // highlighted_offer_tag_style: "550 italic",
        // highlighted_price_tag_size: 14,
        // highlighted_price_tag_color: "#050505",
        // highlighted_price_tag_style: "750 normal",
        // total_footer_text_size: 14,
        // total_footer_text_color: "#000000",
        // total_footer_text_style: "550 normal",
        // total_footer_price_text_size: 16,
        // total_footer_price_text_color: "#000000",
        // total_footer_price_text_style: "750 normal",
        total_footer_background_color: "#fddaf8",
        // total_footer_background_style: "450 normal",
        product_background_color: "#fddaf8",
        product_border_color: "#990783",
        // bundle_widget_bg: "#ffffff00",
        // bundle_widget_font_family: "Custom Store Font",
        // product_img_size: "medium",
        // product_img_show: "all",
        // product_img_border_radius: 10,
        free_gift_header_bg_color: "#990783",
        free_gift_header_color: "#ffffff",
        // free_gift_header_size: 13,
        // free_gift_header_style: "650 normal",
        free_gift_bg_color: "#fddaf8",
        free_gift_text_color: "#303030",
        // free_gift_text_size: 12,
        // free_gift_text_style: "650 normal",
        // free_gift_border: true,
        // free_gift_border_width: 0,
        // free_gift_border_color: "#441144",
        // product_img_border_width: 1,
        product_img_border_color: "#cccccc",
        add_to_cart_bg_color: "#990783",
        add_to_cart_border_color: "#660783",
    },
    PINK: {
        // bundle_title_size: 22,
        bundle_title_color: "#ffc0cb",
        swatches_select_color: "#ffc0cb",
        variant_selector_text_color: "#ffc0cb",
        bundle_border_color: "#ffc0cb",
        // bundle_title_style: "650 normal",
        // product_name_size: 14,
        // product_name_color: "#050505",
        // product_name_style: "450 normal",
        // product_price_size: 10,
        // product_price_color: "#050505",
        // product_price_style: "350 normal",
        // border_color: "#050505",
        // border_width: 2,
        // border_radius: 8,
        background_color: "#F2F4F2",
        // highlighted_offer_tag_size: 12,
        // highlighted_offer_tag_color: "#F8F8F8",
        // highlighted_offer_tag_style: "550 italic",
        // highlighted_price_tag_size: 14,
        // highlighted_price_tag_color: "#050505",
        // highlighted_price_tag_style: "750 normal",
        // total_footer_text_size: 14,
        // total_footer_text_color: "#000000",
        // total_footer_text_style: "550 normal",
        // total_footer_price_text_size: 16,
        // total_footer_price_text_color: "#000000",
        // total_footer_price_text_style: "750 normal",
        total_footer_background_color: "#fff2f5",
        // total_footer_background_style: "450 normal",
        product_background_color: "#fff2f5",
        product_border_color: "#ff37fe",
        // bundle_widget_bg: "#ffffff00",
        // bundle_widget_font_family: "Custom Store Font",
        // product_img_size: "medium",
        // product_img_show: "all",
        // product_img_border_radius: 10,
        free_gift_header_bg_color: "#ffc0cb",
        free_gift_header_color: "#303030",
        // free_gift_header_size: 13,
        // free_gift_header_style: "650 normal",
        free_gift_bg_color: "#fff2f5",
        free_gift_text_color: "#303030",
        // free_gift_text_size: 12,
        // free_gift_text_style: "650 normal",
        // free_gift_border: true,
        // free_gift_border_width: 0,
        // free_gift_border_color: "#441144",
        // product_img_border_width: 1,
        product_img_border_color: "#cccccc",
        add_to_cart_bg_color: "#ff7f9d",
        add_to_cart_border_color: "#cc7f9d",
    },
};
